import { z } from "zod";
import { EAccrualEventType } from "../accrualEventTypes";

export const accrualPolicyEmployeeSchema = z.object({
  companyID: z.string(),
  policyID: z.string(),
  employeeID: z.string(),
  isAssigned: z.boolean(),
  balance: z.number(),
  accrued: z.number(),
  accrualWaitingPeriodBalance: z.number(),
  periodStart: z.string(),
  accrualHistory: z.array(
    z.object({
      periodStart: z.string(),
      accrued: z.number(),
      rolloverToNextPeriod: z.number(),
    })
  ),
  accrualEvents: z
    .array(
      z.object({
        hours: z.number(),
        type: z.nativeEnum(EAccrualEventType),
        employeeCheckID: z.string(),
        modified_by: z.string(),
        timestamp: z.date(),
      })
    )
    .default([]),
  assignmentHistory: z.array(
    z.object({
      isAssigned: z.boolean(),
      updatedAt: z.date(),
    })
  ),
  rolloverDate: z.string().nullable(),
  createdAt: z.date().nullable(),
  updatedAt: z.date().nullable(),
});
